export enum ReportType {
  Eviction = 'Eviction',
  IntakeEviction = 'IntakeEviction',
  Invoice = 'Invoice',
  Task = 'Task',
  BillableItems = 'BillableItems',
}
